import { HandlerType } from "./base/HandlerType";
import { postUrlEncoded } from "./LegacyAxiosUtil";

export class ForgotPasswordParent implements HandlerType {
	protected loading: boolean = false;
	private readonly emailTextBox: JQuery;
	private readonly sendButton: JQuery;
	private readonly messageArea: JQuery;

	constructor(private container: JQuery) {
		this.emailTextBox = container.find("#email");
		this.emailTextBox.val(this.container.data("message"));
		this.sendButton = container.find("#sendButton");
		this.messageArea = container.find("#messageArea");
		this.sendButton.on("click", (event) => void this.onSendClick(event));
	}

	private onLoginSucceeded(data: any) {
		if (data.success) {
			this.windowRedirectTo(data.redirectUrl);
		}
		else {
			if (data.message) {
				this.showMessage(data.message);
			}
		}
	}

	private async onSendClick(event: JQuery.Event): Promise<void> {
		event.preventDefault();

		if (this.loading || !jQuery("form").valid()) {
			return;
		}

		this.sendButton.button("loading");
		this.loading = true;

		const data = {
			email: this.emailTextBox.val(),
		};

		try {
			const response = await postUrlEncoded(this.container.data("url"), data);
			this.onLoginSucceeded(response.data);
		}
		catch {
			// Reported by the default error handler in axios.ts.
		}
		finally {
			this.sendButton.button("reset");
			this.loading = false;
		}
	}

	private showMessage(message: string) {
		this.messageArea.removeClass("hidden");
		this.messageArea.html(message);
	}

	private windowRedirectTo(location: string): void {
		if (location) {
			window.location.href = location;
		}
		else {
			window.location.reload();
		}
	}
}
